<template>
  <div>
    <el-row>
      <el-col :span="2" style="font-size:28px; text-align: center; padding-top: 19px">
        <el-tooltip
          class="item"
          effect="dark"
          content="返回上一级页面"
          placement="bottom-start"
          :disabled="showTooltip"
        >
          <i class="el-icon-arrow-left" @click="onBack" style="cursor: pointer"></i>
        </el-tooltip>
      </el-col>
      <el-col :span="12">
        <h3>
          <span>个人信息设置</span>
        </h3>
      </el-col>
    </el-row>
    <div style="margin: 8px 40px 40px; border-bottom: 1px solid #CCC"></div>
    <div style="max-width: 800px">
      <el-form
        ref="form"
        :model="form"
        :rules="formRules"
        label-width="180px"
        v-loading="showLoading"
      >
        <el-row>
          <el-form-item label="用户代码">{{form.czryDm}}</el-form-item>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="用户姓名">{{form.czryMc}}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="手机号码" prop="sjhm">
              <el-input
                ref="ipt06"
                v-model="form.sjhm"
                placeholder="请输入手机号码"
                maxlength="11"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="邮箱地址" prop="dydz">
              <el-input
                ref="ipt07"
                v-model="form.dydz"
                placeholder="请输入邮箱地址"
                maxlength="50"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="用户密码" prop="password">
            <el-input
              ref="ipt03"
              v-model="form.password"
              placeholder="请输入密码"
              style="width: 40%;"
              maxlength="20"
              type="password"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="新密码" prop="newPassword">
            <el-input
              ref="ipt03"
              v-model="form.newPassword"
              placeholder="请输入新密码"
              style="width: 40%;"
              maxlength="20"
              type="password"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="确认新密码" prop="reNewPassword">
            <el-input
              ref="ipt04"
              v-model="form.reNewPassword"
              placeholder="请再次输入新密码"
              style="width: 40%;"
              type="password"
              maxlength="20"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-row>
        <el-form-item>
          <el-button type="primary" size="small" @click="onSave" v-loading="showBtnLoading">确定</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import _ from "lodash";

let _kits, _form;
export default {
  props: ["entity"],
  data() {
    var checkCzryDm = (rule, value, callback) => {
      const reg = /^[0-9A-Za-z]*$/;
      if (!reg.test(value)) {
        callback(new Error("操作人员代码只能是数字和字母组成"));
      } else {
        callback();
      }
    };
    var checkSfzhm = (rule, value, callback) => {
      if (value == "SUPERADMIN") {
        callback();
        return;
      }
      var city = {
        11: "北京",
        12: "天津",
        13: "河北",
        14: "山西",
        15: "内蒙古",
        21: "辽宁",
        22: "吉林",
        23: "黑龙江 ",
        31: "上海",
        32: "江苏",
        33: "浙江",
        34: "安徽",
        35: "福建",
        36: "江西",
        37: "山东",
        41: "河南",
        42: "湖北 ",
        43: "湖南",
        44: "广东",
        45: "广西",
        46: "海南",
        50: "重庆",
        51: "四川",
        52: "贵州",
        53: "云南",
        54: "西藏 ",
        61: "陕西",
        62: "甘肃",
        63: "青海",
        64: "宁夏",
        65: "新疆",
        71: "中国台湾",
        81: "中国香港",
        82: "中国澳门",
        91: "国外 "
      };
      var tip = "";
      if (
        !value ||
        !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(
          value
        )
      ) {
        tip = "身份证号格式错误";
        callback(new Error(tip));
        return;
      }

      if (!city[value.substr(0, 2)]) {
        tip = "身份证号格式错误";
        callback(new Error(tip));
        return;
      }
      if (value.length == 18) {
        var sBirthday =
          value.substr(6, 4) +
          "-" +
          Number(value.substr(10, 2)) +
          "-" +
          Number(value.substr(12, 2));
        var d = new Date(sBirthday.replace(/-/g, "/"));
        if (
          sBirthday !=
          d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()
        ) {
          tip = "身份证号格式错误非法生日";
          callback(new Error(tip));
          return;
        }
      }
      //18位身份证需要验证最后一位校验位
      if (value.length == 18) {
        value = value.split("");
        //∑(ai×Wi)(mod 11)
        //加权因子
        var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
        //校验位
        var parity = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];
        var sum = 0;
        var ai = 0;
        var wi = 0;
        for (var i = 0; i < 17; i++) {
          ai = value[i];
          wi = factor[i];
          sum += ai * wi;
        }
        var last = parity[sum % 11];
        if (parity[sum % 11] != value[17]) {
          tip = "身份证号格式错误校验位错误";
          callback(new Error(tip));
          return;
        }
      }
      callback();
    };
    var checkZdhhs = (rule, value, callback) => {
      const reg = /^[0-9]*$/;
      if (!reg.test(value)) {
        callback(new Error("最大会话数只能输入数字"));
      } else {
        callback();
      }
    };
    var checkPassword = (rule, value, callback) => {
      if (value == "") {
        if (this.form.newPassword == "" && this.form.reNewPassword == "") {
          callback();
        } else {
          callback(new Error("用户密码不能为空"));
          return;
        }
      }
      callback();
    };
    var checkNewPassword = (rule, value, callback) => {
      if (
        value == "" &&
        this.form.reNewPassword == "" &&
        this.form.password == ""
      ) {
        callback();
      } else if (this.form.password != "") {
        if (value == "") {
          callback(new Error("新密码不能为空"));
          return;
        } else if (
          this.form.reNewPassword != "" &&
          value != this.form.reNewPassword
        ) {
          callback(new Error("两次新密码输入不一致"));
          return;
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    var checkReNewPassword = (rule, value, callback) => {
      if (
        value == "" &&
        this.form.newPassword == "" &&
        this.form.password == ""
      ) {
        callback();
      } else if (this.form.password != "") {
        if (value == "") {
          callback(new Error("确认新密码不能为空"));
          return;
        } else if (
          this.form.newPassword != "" &&
          this.form.newPassword != value
        ) {
          callback(new Error("两次新密码输入不一致"));
          return;
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    var checkSjhm = (rule, value, callback) => {
      const reg = /^1[3|4|5|6|7|8|9][0-9]\d{4,8}$/;
      if (!reg.test(value)) {
        callback(new Error("手机号格式不正确"));
      } else {
        callback();
      }
    };
    let form = {
      czryDm: "",
      czryMc: "",
      sjhm: "",
      dydz: "",
      password: "",
      newPassword: "",
      reNewPassword: ""
    };
    let data = {
      showLoading: true,
      showTooltip: false,
      showBtnLoading: false,
      einvtypeCodeOptions: [],
      form,
      formRules: {
        sjhm: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: "blur"
          },
          {
            validator: checkSjhm,
            trigger: "blur"
          },
          {
            max: 11,
            message: "最多11个数字",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: false,
            message: "请输入密码",
            trigger: "blur"
          },
          {
            max: 20,
            message: "最多20个字符",
            trigger: "blur"
          },
          {
            validator: checkPassword,
            trigger: "blur"
          }
        ],
        newPassword: [
          {
            required: false,
            message: "请输入密码",
            trigger: "blur"
          },
          {
            validator: checkNewPassword,
            trigger: "blur"
          },
          {
            max: 20,
            message: "最多20个字符",
            trigger: "blur"
          }
        ],
        reNewPassword: [
          {
            required: false,
            message: "请再次输入密码",
            trigger: "blur"
          },
          {
            validator: checkReNewPassword,
            trigger: "blur"
          },
          {
            max: 20,
            message: "最多20个字符",
            trigger: "blur"
          }
        ]
      },
      jsOptions: [],
      jsDms: []
    };
    console.log("data is ", data);
    return data;
  },
  methods: {
    onBack() {
      this.$emit("back");
    },
    onSave() {
      // if (
      //   this.form.newPassword != "" &&
      //   this.form.newPassword != this.form.reNewPassword
      // ) {
      //   this.$alert("两次密码内容不一致");
      //   return;
      // }
      _form.submit();
    }
  },
  created() {
    _kits = this.$kits();
    _kits.api.call("GETCONTROL", {}, result => {
      if (result.returnCode == "0000") {
        this.form.czryMc = result.data.czryMc;
        this.form.czryDm = result.data.czryDm;
        this.form.sjhm = result.data.sjhm;
        this.form.dydz = result.data.dydz;
      } else {
        this.$message.error(result.returnMsg);
      }
    });
  },
  mounted() {
    _form = _kits.control.getStandardForm({
      name: "form",
      api: "SAVECONTROL"
    });
    //*
    setTimeout(() => {
      _kits.page.foucus("ipt01");
      this.showLoading = false;
      this.showTooltip = true;
    }, 300);
    //*/
  }
};
</script>
